import React, { useState, useEffect, useContext } from 'react';
import Layout from '../components/Layout';
import Button from '../components/Button';
import Select from '../components/Select';
import Toggle from '../components/Toggle';
import PopUp from '../components/PopUp';
import Steps from '../components/Steps';
import Back from '../components/Back';
import { GlobalContext } from '../reducers/global';
import langs from '../translations/langs';
import shouldShowImperial from '../api/utils/shouldShowImperial';
import showCountryNotice from '../api/utils/showCountryNotice';

const Step1 = ({ setPage }) => {
  const {
    state: { options },
    dispatch,
  } = useContext(GlobalContext);

  const [unit, setUnit] = useState('');

  // Data sets come from language files
  const { dataSets, defaultDataSet } = langs[options.language];
  const dataSetList = dataSets.map((val) => val.name);
  // if this isn't working something is wrong in the translate.json file/files
  const defaultDataSetName = dataSets.filter((val) => val.id === defaultDataSet)[0].name;
  const [dataset, setDataset] = useState(defaultDataSetName);

  const { step1 } = langs[options.language];

  const handleButtonClick = () => {
    setPage('step2');
  };

  useEffect(() => {
    dispatch({
      type: 'OPTIONS_UPDATE',
      dataSet: dataset,
    });
  }, [dataset, dispatch]);

  useEffect(() => {
    dispatch({
      type: 'OPTIONS_UPDATE',
      measurementSystem: unit,
    });
  }, [unit, dispatch]);

  return (
    <Layout>
      {/* <Back
        onClick={() => {
          setPage('step0');
        }}
      /> */}
      <Steps current={1} />
      <h3>{step1.title}</h3>
      <p>{step1.datasetText}</p>
      <Select
        label={step1.datasetLabel}
        name="country"
        placeholder={step1.datasetPlaceholder}
        options={dataSetList}
        value={dataset}
        setValue={setDataset}
      />
      {shouldShowImperial() && <p className="bold">{step1.measurementText}</p>}
      {shouldShowImperial() && <PopUp linkText={step1.measurementLink} modalText={step1.measurementModal} />}
      {shouldShowImperial() && (
        <Toggle
          name="unit"
          leftVal="metric"
          leftText={step1.measurementLeftText}
          leftUnit={step1.measurementLeftUnit}
          rightVal="imperial"
          rightText={step1.measurementRightText}
          rightUnit={step1.measurementRightUnit}
          setValue={setUnit}
        />
      )}
      <Button id="calculator-step1-next" text={step1.nextButton} onClick={() => handleButtonClick()} />
      {showCountryNotice()}
    </Layout>
  );
};

export default Step1;
